<template>
  <div v-if="banks" class="mx-auto">
    <mdb-tbl sm hover>
      <mdb-tbl-head>
        <tr class="title" >
          <th>능력단위 분류번호/능력단위명</th>
          <th>능력단위 요소 코드/능력단위 요소명</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(lecture, ix) in ncstraining.ncsSpecials" :key="ix">
          <td class="bolder">
            {{lecture.name}}/{{lecture.code}}
          </td>
          <td>
            <div v-for="(unit, ux) in lecture.units" :key="ux">
              <span class="pointer" @click="$emit('edit-bank', banks[unit.code])">
                {{unit.name}}/{{unit.code}}
                <mdb-badge pill color="indigo">{{count(unit.code)}}</mdb-badge>
              </span>
            </div>
          </td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
  </div>
</template>
<script>
import { } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import QuestionBank from '@/models/QuestionBank'
export default {
  name: 'StaffNcsTrainingQuestionBankView',
  props: ['ncstraining', 'banks'],
  data: () => ({
    TAG: 'StaffNcsTrainingQuestionBankView'
  }),
  methods: {
    onBack () {
      this.$router.back()
    },
    count (code) {
      if (!this.banks[code]) return 0
      return this.banks[code].questions.length
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      console.log('')
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      console.log('')
    }
  }
}
</script>
